import loopback from '@/services/loopback'

const API_ENDPOINT = '/referral-program/active'

export default {
  async getActiveSetting () {
    try {
      if (!loopback.hasToken()) return { success: false }

      const referralProgramSetting = await loopback.get(API_ENDPOINT)
      if (referralProgramSetting.status === 'success') {
        return { success: true, data: referralProgramSetting.data }
      }
      return { success: false }
    } catch (err) {
      console.error('Erro ao buscar configuração do API Indica')
      return { success: false, error: err }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/referral-program.js